import { ReactElement } from 'react';

import { css } from '@emotion/react';

import { palette } from '@lib/styles/palette';

import { emphasizeText, underLineText } from '../fraudSearchResult.style';

export default function ResultDetailGuide(): ReactElement {
  return (
    <p css={resultDetailGuide}>
      &#40;등록된 피해사례가{' '}
      <span css={emphasizeText(true)}>
        실제 사기 거래와는 정확히 일치하지 않을 수 있습니다.
      </span>{' '}
      <span css={underLineText(palette.blue5)}>모니터링 데이터는</span> 통계에
      기반하여 사기거래 가능성을 확률적으로 판단한 정보입니다. &#41;
    </p>
  );
}

const resultDetailGuide = css`
  font-size: 13px;
  grid-column: 1/3;
`;
